export default "__VITE_ASSET__Q3tli4wU__"